import useEvent from '@lyearn/core/hooks/useEvent';

import { useCancelGenerativeTaskMutation } from '../../graphql/mutations/generated/cancelGenerativeTask';

export const useCancelGenerativeTask = (generativeTaskId: string) => {
  const [{ fetching }, executeCancelGenerativeTask] = useCancelGenerativeTaskMutation();

  const onStopGenerating = useEvent(async () => {
    await executeCancelGenerativeTask({
      input: {
        generativeTaskId,
      },
    });
  });

  return { fetching, onStopGenerating };
};
